import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import { isEmpty, isNull } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import Spinner from '../../common/spinners/Spinner';
import { useFindInsurances } from '../hooks/useFindInsurances';
import { useFindSocialInsurances } from '../../SocialInsuranceInformation/hooks';
import { PaymentsProfileView } from './PaymentsProfileView';
import { DISALLOWED_ARCHIVE_SCC_STATUSES } from '../constants';
import today from '../../utils/today';
var findPrimaryInsuranceRelationship = function findPrimaryInsuranceRelationship(socialInsurances, insurance) {
  return _filterInstanceProperty(socialInsurances).call(socialInsurances, function (socialInsurance) {
    var _socialInsurance$prim, _socialInsurance$plan, _context;
    return _includesInstanceProperty(DISALLOWED_ARCHIVE_SCC_STATUSES).call(DISALLOWED_ARCHIVE_SCC_STATUSES, socialInsurance.insurance_status) && (isNull(socialInsurance.expired_at) || new Date(socialInsurance.expired_at) > today()) && (((_socialInsurance$prim = socialInsurance.primary_health_insurance) === null || _socialInsurance$prim === void 0 ? void 0 : _socialInsurance$prim.id) === insurance.id || ((_socialInsurance$plan = socialInsurance.plan.required_health_plans) === null || _socialInsurance$plan === void 0 ? void 0 : _includesInstanceProperty(_context = _mapInstanceProperty(_socialInsurance$plan).call(_socialInsurance$plan, function (el) {
      return el.id;
    })).call(_context, insurance.plan.id)));
  });
};
export var Insurances = function Insurances(_ref) {
  var contact = _ref.contact,
    lastUpdate = _ref.lastUpdate,
    shouldShowLastUpdate = _ref.shouldShowLastUpdate;
  var _useFindInsurances = useFindInsurances(contact.id),
    insurances = _useFindInsurances.insurances,
    isLoading = _useFindInsurances.isLoading;
  var _useFindSocialInsuran = useFindSocialInsurances(contact.id),
    socialInsurances = _useFindSocialInsuran.socialInsurances,
    isSccLoading = _useFindSocialInsuran.isSccLoading;
  if (isLoading || isSccLoading) return /*#__PURE__*/React.createElement(Spinner, null);
  if (!isEmpty(insurances)) {
    return insurances === null || insurances === void 0 ? void 0 : _mapInstanceProperty(insurances).call(insurances, function (insurance) {
      return /*#__PURE__*/React.createElement(PaymentsProfileView, {
        contact: contact,
        insurance: insurance,
        key: "payments-insurance-".concat(insurance.id),
        lastUpdate: lastUpdate,
        shouldShowLastUpdate: shouldShowLastUpdate,
        linkedScc: findPrimaryInsuranceRelationship(socialInsurances, insurance)
      });
    });
  }
  return /*#__PURE__*/React.createElement("p", {
    className: "no-insurance"
  }, "No Insurance Added.");
};
Insurances.propTypes = {
  contact: PropTypes.object.isRequired,
  lastUpdate: PropTypes.object.isRequired,
  shouldShowLastUpdate: PropTypes.bool.isRequired
};
//# sourceMappingURL=Insurances.js.map